import { useState } from 'react'
import { Modal, Fade, Backdrop } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { applicationsStyles } from '../../styles'

const ActiveLink = ({ rowData }) => {
   const classes = applicationsStyles()
   const [statusModal, setStatusModal] = useState(false)

   return (
      <>
         {rowData.mutualWorld ? (
            <span className={classes.buttonImage} onClick={() => setStatusModal(true)}>
               Ver imagen
            </span>
         ) : (
            <a>No disponible</a>
         )}
         {statusModal && (
            <Modal
               aria-labelledby="transition-modal-title"
               aria-describedby="transition-modal-description"
               className={classes.containerModal}
               open={statusModal}
               onClose={() => setStatusModal(false)}
               closeAfterTransition
               BackdropComponent={Backdrop}
               BackdropProps={{
                  timeout: 500
               }}
            >
               <Fade in={statusModal}>
                  <div className={classes.containerPaper}>
                     <div className={classes.containerImg}>
                        <div onClick={() => setStatusModal(false)} className={classes.containerIcon}>
                           <CloseIcon />
                        </div>
                        <img src={rowData.mutualWorld.image} alt="" />
                     </div>
                  </div>
               </Fade>
            </Modal>
         )}
      </>
   )
}

export default ActiveLink
